import { render, staticRenderFns } from "./UserArea.vue?vue&type=template&id=d91d995a&scoped=true"
import script from "./UserArea.vue?vue&type=script&lang=js"
export * from "./UserArea.vue?vue&type=script&lang=js"
import style0 from "./UserArea.vue?vue&type=style&index=0&id=d91d995a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91d995a",
  null
  
)

export default component.exports